import { InjectionToken } from '@angular/core';

export interface NewsfeedServiceConfigInterface {
  newsfeedApiUrl: string;
  quicklinksApiUrl: string;
  fairDataGatewayUrl: string;
  userHistoryUrl: string;
  initialItemsCount: number;
  loadMoreItemsCount: number;
}

export const NEWSFEED_SERVICE_CONFIG = new InjectionToken<NewsfeedServiceConfigInterface>('NEWSFEED_SERVICE_CONFIG');
